var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMouseOver = function SvgMouseOver(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.596 16.541a1 1 0 0 1-1.712-.585l-.878-7.845c-.097-.865.881-1.432 1.584-.918l6.383 4.662a1 1 0 0 1-.346 1.778l-1.919.482 2.184 3.782a.997.997 0 1 1-1.727.997L7.98 15.113 6.596 16.54zm5.985-8.766a1 1 0 1 0 0 2h7a1 1 0 0 0 0-2h-7zm2 5a1 1 0 0 1 1-1h2a1 1 0 0 1 0 2h-2a1 1 0 0 1-1-1zm0 3a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2h-1z"
  })));
};
export default SvgMouseOver;